import {isArray, isBoolean, isNull, isNumber, isUndefined} from "util";

/**
 * Json converter helper.
 */
export default class JsonConverter {
	/**
	 * Remove all fields from json object that are empty, null or undefined.
	 * @param obj object to convert.
	 * @return {any} cleaned up object.
	 */
	static removeEmptyFields(obj: any) {
		let newObj: any = {};
		Object.keys(obj).forEach((key: string) => {
			if (!isUndefined(obj[key]) && !isNull(obj[key]) && (obj[key] != "" || isArray(obj[key]) || isNumber(obj[key]) || isBoolean(obj[key])))
				newObj[key] = obj[key]
		});
		return newObj;
	}
}